module.exports = __webpack_public_path__ + "img/receipt.193a5899.svg";